





































import Vue from "vue"

export interface EmitArgumentOfScroll {
  offsetTop: number
}

interface SideMenuParams {
  clientHeight: number
  offsetTop: number
  offsetLeft: number
  windowHeight: number
}

interface DataType {
  /**
   * サイドバーをfixさせる際に位置の計算で利用するパラメーター
   */
  sideMenuParams: SideMenuParams | null
}

const makeSideMenuParams = (
  sideMenuParams: SideMenuParams,
  topSpacing: number
) => ({
  top: `${topSpacing}px`,
  left: `${sideMenuParams.offsetLeft}px`,
  "max-height": `${sideMenuParams.windowHeight - topSpacing}px`,
  position: "fixed",
})

const isFixedSideBar = (
  sideMenuParams: SideMenuParams,
  topSpacing: number
): boolean => sideMenuParams.offsetTop - topSpacing <= 0

export default Vue.extend({
  props: {
    isGrayBackground: {
      type: Boolean,
      default: false,
    },
    hasScrollEvent: {
      type: Boolean,
      default: false,
    },
    defaultOffsetTop: {
      type: Number,
      default: 0,
    },
    disableMinHeight: {
      type: Boolean,
      default: false,
    },
    isMaxWidth: {
      type: Boolean,
      default: false,
    },
    hasRadius: {
      type: Boolean,
      default: false,
    },
    hasPaddingBottom: {
      type: Boolean,
      default: true,
    },
    hasLargePaddingBottom: {
      type: Boolean,
      default: false,
    },
    /**
     * サイドバーをfixさせるかどうかを指定できる。
     */
    isFixedSideBar: {
      type: Boolean,
      default: false,
    },
    /**
     * サイドバーをfixedさせた場合に利用される値で、
     * fixedされたサイドバーの上部に設けるスペースを指定できる。（単位はpx）
     */
    sideBarTopSpacing: {
      type: Number,
      default: 0,
    },
    /**
     * 通常使用しているContainerのWidthよりも広いWidthを指定する場合に利用する。
     */
    isWideContainerWidth: {
      type: Boolean,
      default: false,
    },
  },
  data(): DataType {
    return {
      sideMenuParams: null,
    }
  },
  computed: {
    sideMenuInnerStyle(): object | undefined {
      return this.isFixedSideBar &&
        this.sideMenuParams &&
        isFixedSideBar(this.sideMenuParams, this.sideBarTopSpacing)
        ? makeSideMenuParams(this.sideMenuParams, this.sideBarTopSpacing)
        : undefined
    },
  },
  beforeMount() {
    if (this.hasScrollEvent) {
      window.addEventListener("scroll", this.handleScroll)
      window.addEventListener("resize", this.handleScroll)
    }
  },
  mounted() {
    this.$nextTick().then(() => {
      this.updateSideMenuParams()
      window.scrollTo(0, this.defaultOffsetTop)
    })
  },
  destroyed() {
    if (this.hasScrollEvent) {
      window.removeEventListener("scroll", this.handleScroll)
      window.removeEventListener("resize", this.handleScroll)
    }
  },
  methods: {
    handleScroll() {
      this.updateSideMenuParams()

      const emitArg: EmitArgumentOfScroll = {
        offsetTop: window.scrollY,
      }
      this.$emit("scroll", emitArg)
    },
    updateSideMenuParams() {
      if (this.isFixedSideBar) {
        const sideMenuRef = this.$refs.sideMenu as HTMLElement
        this.sideMenuParams = {
          clientHeight: sideMenuRef.offsetTop,
          offsetTop: sideMenuRef.getBoundingClientRect().top,
          offsetLeft: sideMenuRef.getBoundingClientRect().left,
          windowHeight: window.innerHeight,
        }
      }
    },
  },
})
